import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'mf-header',
});

export async function getHeader(modelConfig) {
    const query = JSON.stringify(modelConfig);

    return backendEndpoint.get('', {
        headers: {
            Accept: 'application/json',
        },
        data: {},
        params: {
            vm: query,
        },
    });
}
